import {Injectable} from '@angular/core';
import {GenericService} from '../../core/commons/generic.service';
import {AuthService} from '../../core/security/auth.service';
import {QueryOptions} from '../../core/commons/query.options';
import {FormView} from '../domain/form-view';
import {Observable} from 'rxjs/Observable';
import {PaginationPage} from 'app/core/commons/pagination-page';
import {FormViewData} from '../domain/form-view-data';
import {BaseRequestOptions, Headers, RequestMethod, ResponseContentType, URLSearchParams} from '@angular/http';
import {HttpErrorResponse} from '@angular/common/http';
import {FormViewFieldData} from '../domain/form-view-field-data';

@Injectable()
export class FormViewService extends GenericService<FormView> {

    private resourcePath: string = '/view';

    constructor(public authService: AuthService) {
        super(authService);
    }

    protected valueToEntity(value: Object): FormView {
        return new FormView(value);
    }

    protected getResourcePath(): string {
        return this.resourcePath;
    }

    public getDefaultQueryOptions(): QueryOptions {
        return new QueryOptions();
    }

    public findAllActive(queryOptions: QueryOptions = this.getDefaultQueryOptions()): Observable<PaginationPage<FormView>> {
        return this.doRequest(queryOptions.getQueryRequestOptions().merge({
            url: this.baseUrl + this.getResourcePath() + '/find-all-active'
        }))
            .map(res => res.json())
            .concatMap(json => Observable.from(json.content)
                .concatMap(value => this.mapValueToEntityQuery(value))
                .toArray()
                .map(content => new PaginationPage({...json, content: content}))
            );
    }

    public findAllFilled(queryOptions: QueryOptions = this.getDefaultQueryOptions()): Observable<PaginationPage<FormViewData>> {
        return this.doRequest(queryOptions.getQueryRequestOptions().merge({
            url: this.baseUrl + this.getResourcePath() + '/find-all-filled'
        }))
            .map(res => res.json())
            .concatMap(json => Observable.from(json.content)
                .concatMap(value => this.mapValueToEntityQuery(value))
                .toArray()
                .map(content => new PaginationPage({...json, content: content}))
            );
    }

    public fill(data: FormViewData): Observable<any> {
        return this.doRequest({
            url: this.baseUrl + this.getResourcePath() + '/fill',
            method: RequestMethod.Post,
            body: JSON.stringify(data)
        });
    }

    public download(id: number): Observable<any> {
        const headers = new Headers();
        headers.set('Accept', 'application/pdf');
        return this.doRequest({
            url: this.baseUrl + this.getResourcePath() + '/download/' + id,
            method: RequestMethod.Get,
            headers: headers,
            responseType: ResponseContentType.Blob
        }).map(res => new Blob([res.blob()], {type: 'application/pdf'}));
    }

    public getViewData(id: number, replacedValues): Observable<FormViewData> {
        const ro = this.getDefaultQueryOptions().getQueryRequestOptions().merge({
            url: this.baseUrl + this.getResourcePath() + '/get-filled/' + id
        });
        ro.params.append('replace-values', replacedValues);
        return this.doRequest(ro)
            .map(res => new FormViewData(res.json()))
            .catch((e: any) => Observable.throw(this.errorHandler(e)));
    }

    public updateViewData(viewData: FormViewData) {
        return this.doRequest({
            url: this.baseUrl + this.getResourcePath() + '/data/update',
            method: RequestMethod.Put,
            body: JSON.stringify(viewData)
        })
            .map(res => new FormViewData(res.json()));
    }

    public deleteViewDataFields(viewData: FormViewFieldData[]) {
        const reqOptions = new BaseRequestOptions();
        reqOptions.url = this.baseUrl + this.getResourcePath() + '/data/fields';
        reqOptions.method = RequestMethod.Delete;
        reqOptions.params = new URLSearchParams();
        reqOptions.params.append('ids', viewData.map(v => v.id).join(','));

        return this.doRequest(reqOptions);
    }

    errorHandler(error: HttpErrorResponse) {
        if (error.status == 401)
            console.log(error);
    }

}



// WEBPACK FOOTER //
// ./src/app/form-views/services/form-view.service.ts